import {Component, Inject, OnInit} from '@angular/core';
import {AppService} from "../../../../../../../../app.service";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {ActivationT} from "../../../../../../interfaces/activation";
import {DateTime, Duration} from 'luxon';
import {AuthService} from '../../../../../../../../core/auth/auth.service';

@Component({
  selector: 'app-history-dialog',
  templateUrl: './history-dialog.component.html',
  styleUrls: ['./history-dialog.component.scss']
})
export class HistoryDialogComponent implements OnInit {


  constructor(@Inject(MAT_DIALOG_DATA)
              public data: { user_id: string },
              public app: AppService,
              public auth: AuthService,
              public dialog: MatDialog
  ) {
  }

  activations: ActivationT[] = null;

  ngOnInit(): void {
    this.getActivations();
  }

  async getActivations() {
    this.app.dialog.loader({
      title: 'Laden von Nutzerdaten'
    });

    this.activations = await this.app.getActivations(this.data.user_id).catch(err => {
      console.error(err);
      return null;
    });

    this.app.dialog.closeLoader();
  }

  extendActivation(activation: ActivationT) {
    if (!activation.used && activation.valid) {
      let act = Object.assign({}, activation);
      // let expiry = DateTime.fromISO(activation.expires);
      let now = DateTime.now();

      let dur = Duration.fromObject({days: 14});
      let expiry = now.plus(dur);

      act.expires = expiry.toISO();
      act.upd = (new Date()).toISOString();
      act.upd_id = this.auth.user.id;

      this.app.dialog.loader({
        title: 'Moment mal...'
      });
      this.app.updateActivation(act).then((res) => {
        this.app.dialog.closeLoader();
        console.log(res);
        this.activations.find(a => {
          if(a.id === act.id) {
            a.expires = act.expires;
            a.upd = act.upd;
          }
        })
      }).catch((err) => {
        this.app.dialog.closeLoader();
        console.error(err);
      })
    }
  }

  canExtend(activation: ActivationT) {
    let now = DateTime.now();
    let expiry = DateTime.fromISO(activation.expires);

    // console.log(now, expiry, now.ts > expiry.ts);
    return (now.ts > expiry.ts) && !activation.used;
  }

}
